import { SelectOptions } from "../../../interfaces/CoreInterfaces";

export const Bank_Account_Types: Array<SelectOptions> = [
  { label: "Operating", value: "0" },
  { label: "Reserve", value: "1" },
  { label: "Other", value: "2" }
]